import { registerPlugin } from '@capacitor/core';
import type { MetaAppEventsPlugin } from './definitions';

export const MetaAppEvents = registerPlugin<MetaAppEventsPlugin>('MetaAppEvents', {
  web: () => import('./web').then(module => new module.MetaAppEventsWeb()),
});

export type { MetaAppEventsPlugin, MetaTrackingStatus } from './definitions';
